var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM11.8775 8.7333C12.6322 8.7333 13.2441 8.12143 13.2441 7.36665C13.2441 6.61187 12.6322 6 11.8775 6C11.1227 6 10.5108 6.61187 10.5108 7.36665C10.5108 8.12143 11.1227 8.7333 11.8775 8.7333ZM10.1601 10.5284C10.1779 10.4452 10.2464 10.3823 10.3309 10.3718L12.4302 10.1094C12.7715 10.0667 13.053 10.3733 12.9813 10.7097L11.8458 16.0383C11.6676 16.7033 12.1421 16.8554 12.6851 16.6534C12.8462 16.5935 13.0431 16.7291 13.0084 16.8975V16.8975C13.0013 16.9317 12.9854 16.9632 12.9609 16.9881C11.9615 18.0054 9.5827 18.2313 10.0634 16.1218L11.0451 11.4859C11.0946 11.2608 11.0451 11.0872 10.7095 10.9882L10.2887 10.9108C10.1779 10.8904 10.1058 10.7825 10.1294 10.6723L10.1601 10.5284Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.cbab8e79.svg";
export { ForwardRef as ReactComponent };